import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket/store'
import { type IResponseCallTransferSucceeded } from 'entities/Call/api/types'
import { useEntitiesContext } from 'entities/EntitiesExport'

export const useEventCallTransferSucceeded = () => {
  const { websocket, callStore } = useEntitiesContext()

  const handle = (data: IResponseCallTransferSucceeded) => {
    if (!callStore.isOwnTransferLeg(data.agent_call_sid)) return

    callStore.endTransferredCall(data.agent_call_sid)
  }

  useEffect(() => websocket.on(WebsocketEvent.CallCallTransferSucceeded, handle), [callStore])
}
